'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/regular';
import { faChevronDown } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faSliders } from '@awesome.me/kit-94e593bf23/icons/classic/light';
const CategoryNav = dynamic(() => import('./CategoryNav'), {
  ssr: false
});
import CategoryDropdown from './CategoryDropdown';
import RandomProductImage from '@/app/_components/RandomProductImage';
import '@/app/_styles/category.css';

// Quick nav item with hover dropdown for subcategories
const QuickNavItem = t0 => {
  const $ = _c(15);
  const {
    category
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = category.children && category.children.length > 0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    t2 = () => setIsOpen(false);
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== hasChildren) {
    t3 = hasChildren && <FontAwesomeIcon icon={faChevronDown} className="text-3xs" />;
    $[2] = hasChildren;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== category.category_name || $[5] !== category.url || $[6] !== t3) {
    t4 = <Link href={category.url} className="flex items-center gap-1 text-base text-light font-normal capitalize mr-5 transition-colors hover:text-primary">{category.category_name}{t3}</Link>;
    $[4] = category.category_name;
    $[5] = category.url;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== category.children || $[9] !== hasChildren || $[10] !== isOpen) {
    t5 = hasChildren && isOpen && <div className="absolute top-full left-0 pt-2 z-50"><div className="bg-white shadow-lg border border-gray-10 rounded min-w-[180px] py-2">{category.children.map(_temp)}</div></div>;
    $[8] = category.children;
    $[9] = hasChildren;
    $[10] = isOpen;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="relative" onMouseEnter={t1} onMouseLeave={t2}>{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const CategoryLanding = t0 => {
  const $ = _c(19);
  const {
    category
  } = t0;
  let t1;
  if ($[0] !== category.children) {
    t1 = category.children || [];
    $[0] = category.children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const children = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center border-b-1 border-gray-8 pb-3"><FontAwesomeIcon icon={faSliders} className="text-primary text-xl mr-3" width="16" /><span className="text-md text-primary">Filter</span></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== category) {
    t3 = <aside className="relative flex flex-col items-start h-full hidden lg:block w-[225px] min-w-[225px] mr-12 pt-4">{t2}<CategoryNav category={category} /></aside>;
    $[3] = category;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== category || $[6] !== children) {
    t4 = category.category_parent_id == 0 ? <><CategoryDropdown identifier="category-dropdown" label="Select Category" categoires={children} selectedCategory={category} selected_value={category.category_id} /><div className="hidden lg:flex items-center border-b-1 border-gray-8 mt-4 pb-4 mb-8"><div className="font-normal text-base text-light-3 capitalize whitespace-nowrap mr-4">{category.category_name} categories</div><FontAwesomeIcon icon={faChevronRight} className="text-light-3 text-xs mr-4" />{children.map(_temp2)}</div><div className="flex items-center mb-3 lg:mt-4"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-2xl mr-2" /><h1 className="text-4xl text-primary font-extralight block capitalize">{category.category_name}</h1></div><div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-3 sm:gap-4 md:gap-6 xl:gap-8 mb-16 pb-4 lg:bg-gray-3">{children.map(_temp3)}</div></> : <><div className="flex items-center mb-3 lg:mt-4"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-xl mr-1" /><h1 className="text-xl text-light font-extralight block capitalize">{category.category_name}</h1></div><div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3 sm:gap-4 md:gap-6 xl:gap-8 mb-20">{children.map(_temp4)}</div></>;
    $[5] = category;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== category.category_name || $[9] !== children) {
    let t6;
    if ($[11] !== category.category_name) {
      t6 = (subCategory_2, index_2) => subCategory_2.children && subCategory_2.children.some(_temp5) && <div key={subCategory_2.category_id || index_2}><h2 className="flex items-center gap-2 block mb-5"><div className="hidden text-md capitalize text-light">{category.category_name}</div><div className="hidden"><FontAwesomeIcon icon={faChevronRight} className="text-light-4 text-3xs" /></div><div className="text-xl capitalize font-light text-light">{subCategory_2.category_name}</div></h2>{subCategory_2.use_brand_layout ? <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-y-20 gap-x-6 md:gap-x-10 2xl:gap-x-20 mb-20">{subCategory_2.children.map(_temp6)}</div> : <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6 xl:gap-8 mb-20">{subCategory_2.children.map(_temp7)}</div>}</div>;
      $[11] = category.category_name;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t5 = children.map(t6);
    $[8] = category.category_name;
    $[9] = children;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="w-full mb-[150px]">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t6) {
    t7 = <div className="flex flex-col lg:flex-row align-start">{t3}{t6}</div>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default CategoryLanding;
function _temp(child, index) {
  return child.url && <Link key={child.category_id || index} href={child.url} className="block px-4 py-2 text-xs text-light capitalize hover:bg-gray-3 hover:text-primary transition-colors">{child.category_name}</Link>;
}
function _temp2(subCategory, index) {
  return subCategory.url && <QuickNavItem key={subCategory.category_id || index} category={subCategory} />;
}
function _temp3(subCategory_0, index_0) {
  return subCategory_0.images?.landing?.file_name && subCategory_0.url && <Link key={subCategory_0.category_id || index_0} href={subCategory_0.url} className="group"><div className="aspect-square overlay-block flex justify-center bg-white relative mb-4 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-3/4 after:border-b after:border-gray-5 md:group-hover:after:border-primary"><Image className="w-full h-auto scale-90 lg:transition-all lg:duration-400 lg:group-hover:scale-100 pt-6 px-6 pb-1" src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subCategory_0.images.landing.file_name}`} overrideSrc={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subCategory_0.images.landing.file_name}`} alt={subCategory_0.images.landing.alt || `${subCategory_0.category_name} category image`} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={subCategory_0.images.landing.width} height={subCategory_0.images.landing.height} quality={90} sizes="(max-width: 768px) 100vw, (max-width: 1024px) 33vw, 25vw" /></div><div className="text-center text-md capitalize mt-3">{subCategory_0.category_name}</div></Link>;
}
function _temp4(subCategory_1, index_1) {
  return subCategory_1.images?.landing?.file_name && subCategory_1.url && <Link key={subCategory_1.category_id || index_1} href={subCategory_1.url} className="group"><div className="aspect-square overlay-block"><Image className="w-full h-auto scale-90 lg:transition-all lg:duration-400 lg:group-hover:scale-100 p-4" src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subCategory_1.images.landing.file_name}`} overrideSrc={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subCategory_1.images.landing.file_name}`} alt={subCategory_1.images.landing.alt || `${subCategory_1.category_name} category image`} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={subCategory_1.images.landing.width} height={subCategory_1.images.landing.height} quality={90} sizes="(max-width: 768px) 50vw, (max-width: 1280px) 33vw, (max-width: 1536px) 25vw, 20vw" /></div><div className="text-lg text-light capitalize mt-2 group-hover:text-primary">{subCategory_1.category_name}</div></Link>;
}
function _temp5(gc) {
  return (gc.images?.landing?.file_name || gc.images?.brand_logo_right?.file_name) && gc.url;
}
function _temp6(childSubCategory, childIndex) {
  return childSubCategory.url && <Link key={childSubCategory.category_id || childIndex} href={childSubCategory.url} className="group"><div className="group relative w-full overlay-block aspect-[10/8.5] mb-2">{childSubCategory.active_sale && <div className="absolute top-0 left-0 z-20 p-2 font-medium text-sm text-red">Sale</div>}{childSubCategory.images?.brand_logo_right?.file_name && <Image className="absolute top-8 right-5 z-10 scale-75 origin-top-right" src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${childSubCategory.images.brand_logo_right.file_name}`} overrideSrc={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${childSubCategory.images.brand_logo_right.file_name}`} alt={childSubCategory.images.brand_logo_right.alt || childSubCategory.category_name} width={childSubCategory.images.brand_logo_right.width} height={childSubCategory.images.brand_logo_right.height} />}<RandomProductImage images={childSubCategory.featured_product_images} className="absolute block bottom-4 left-4 z-0 w-[120px] h-[120px] object-contain" alt={childSubCategory.category_name} width={120} height={120} /></div><div className="flex justify-between items-baseline capitalize mt-2"><span className="text-lg group-hover:text-primary">{childSubCategory.category_name}</span>{childSubCategory.active_sale?.sale_title && <span className="text-red text-lg">{childSubCategory.active_sale.sale_title}</span>}</div></Link>;
}
function _temp7(childSubCategory_0, childIndex_0) {
  return childSubCategory_0.images?.landing?.file_name && childSubCategory_0.url && <Link key={childSubCategory_0.category_id || childIndex_0} href={childSubCategory_0.url} className="group"><div className="flex items-center justify-center aspect-square overlay-block"><Image className="max-w-[250px] scale-90 lg:transition-all lg:duration-400 lg:group-hover:scale-100 p-4" src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${childSubCategory_0.images.landing.file_name}`} overrideSrc={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${childSubCategory_0.images.landing.file_name}`} alt={childSubCategory_0.images.landing.alt || `${childSubCategory_0.category_name} category image`} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={childSubCategory_0.images.landing.width} height={childSubCategory_0.images.landing.height} quality={90} sizes="(max-width: 768px) 50vw, (max-width: 1280px) 33vw, 25vw" /></div><div className="text-lg text-light capitalize mt-2 group-hover:text-primary">{childSubCategory_0.category_name}</div></Link>;
}